/**
 * Shared identifier for the AI-generated recording-consent task that is
 * inserted into the suggested-actions list at the start of a call. The task
 * is marked as answered (added to `state.aiAnalysis.answeredPrompts`) once
 * the officer has obtained the caller's consent.
 *
 * Re-export here so non-header components (e.g. the in-call avatar dialog)
 * can gate features on consent without importing from a peer component.
 */
export const RECORDING_CONSENT_TASK_ID = 'system-recording-consent-required';
